import {
  HttpErrorResponse,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from "@angular/common/http";
import { catchError, Observable } from "rxjs";
import { AuthService } from "../services";
import { inject } from "@angular/core";
import { ErrorStatusEnum } from "../enums";
import { usersEndpointConfig } from "../configs";

export const authInterceptor: HttpInterceptorFn = (
  request: HttpRequest<any>,
  next: HttpHandlerFn,
): Observable<any> => {
  const authService: AuthService = inject(AuthService);
  return next(request).pipe(
    catchError((error: HttpErrorResponse) => {
      if (
        (error.status === ErrorStatusEnum.UNAUTHORIZED ||
          error.status === ErrorStatusEnum.NOT_FOUND) &&
        request.url.endsWith(usersEndpointConfig.profileUrl())
      ) {
        authService.performIdentityLogout();
      }
      throw error;
    }),
  );
};
